<template>
  <div class="add-to-board-modal">
    <el-dialog
      v-model="modelValueState"
      :title="$trans('web_search.add_to_board_modal.board_request_title')"
      :show-close="false"
      @closed="resetForm"
    >
      <template #header>
        <div class="modal-header">
          <span class="title-col">
            {{ $trans('web_search.add_to_board_modal.added_to_board') }}
          </span>
          <CloseModalButton @click="modelValueState = false" />
        </div>
      </template>

      <template v-if="successMessage">
        <el-row>
          <div class="success-wrapper">{{ successMessage }}</div>
        </el-row>
      </template>

      <template v-else>
        <el-row class="your-selection-content">
          <el-col style="border-bottom: 1px solid">
            <div class="tag-header">
              <span>{{ $trans('web_search.add_to_board_modal.search_terms') }}</span>
            </div>
            <div class="match-rate-header">
              <span>{{ $trans('web_search.add_to_board_modal.match_rate') }}</span>
            </div>

            <div class="your-selection-row">
              <div>
                <img :src="profile.avatar_url" alt="Avatar" />
              </div>

              <div>
                <template
                  v-for="(filter, index) in profile.activeSkills"
                  :key="index"
                >
                  <Tag size="small" :text="filter.name" />
                </template>

                <template
                  v-for="(filter, index) in profile.activeFilters"
                  :key="index"
                >
                  <Tag size="small" :text="filter" />
                </template>
              </div>

              <div class="match-rate">
                <div>
                  <span class="color-black">
                    {{ profile.percentage_score_avg }}
                  </span>
                  <span class="color-grey"> / 100</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-button type="primary" @click="addToBoard">
              {{ $trans('web_search.add_to_board_modal.open_board') }}
            </el-button>

            <el-col style="padding: unset;">
              <el-button type="primary" @click="handleClose">
                {{ $trans('web_search.add_to_board_modal.select_more') }}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
      </template>

      <template #footer v-if="!successMessage">
        <AuthFooterModal />
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Tag from "./../Utils/Tag.vue";
import CloseModalButton from "./CloseModalButton.vue";
import AuthFooterModal from "./../Auth/AuthFooterModal";

export default {
  components: {
    Tag,
    CloseModalButton,
    AuthFooterModal,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    profile: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue", "closed", "addToBoard", "close"],
  computed: {
    modelValueState: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
      this.modelValueState = false;
    },
    addToBoard() {
      this.$emit("addToBoard", this.profile);
      this.modelValueState = false;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  background-color: #ededed;
  padding-top: 15px;
}

.your-selection-content {
  border: 1px solid #eee;
  padding: 15px;
  margin-bottom: 0px;
}

.your-selection-row {
  display: grid;
  grid-template-columns: 50px 1fr auto;
  gap: 15px;
  align-items: center;
}

.your-selection-row img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.match-rate {
  text-align: right;
}

.color-black {
  color: #303133;
  font-weight: bold;
}

.color-grey {
  color: #909399;
}

.success-wrapper {
  text-align: center;
  font-size: 1.2rem;
  color: #67c23a;
  padding: 20px;
}

.error-wrapper {
  color: #f56c6c;
}

.center {
  text-align: center;
}
.el-form-item.center .el-form-item__content {
  justify-content: center;
}

.add-to-board-modal :deep(.el-dialog) {
  --el-dialog-width: 750px;
  top: -100px !important;
}

.center {
  text-align: center;
}

.success-wrapper {
  color: #81bc8f;
  text-align: center;
  font-weight: bold;
  width: 100%;
}

.error-wrapper {
  color: #ff6b65;
  font-style: italic;
}

.add-to-board-modal :deep(.el-dialog .el-dialog__header) {
  padding-bottom: 0;
}

.add-to-board-modal :deep(.el-dialog .el-dialog__body) {
  padding-top: unset;
}

.add-to-board-modal :deep(.el-dialog .el-dialog__footer) {
  padding: 0;
}

.add-to-board-modal
  :deep(
    .el-form--default.el-form--label-top .el-form-item .el-form-item__label
  ) {
  margin-bottom: 0px;
}

.add-to-board-modal :deep(.center .el-form-item__content) {
  justify-content: center;
  margin-top: 57px;
}

.add-to-board-modal :deep(.el-form-item__content) {
  flex-wrap: unset;
}

.login-modal :deep(.el-form-item:last-child) {
  margin-bottom: 0;
}

.add-to-board-modal .el-row {
  background-color: #ededed;
  color: rgb(60, 60, 60);
  padding-bottom: 18px;
}

.add-to-board-modal .el-row:first-child {
  padding-top: 18px;
}

.add-to-board-modal .el-col {
  padding: 0 15px;
}

.add-to-board-modal .el-button {
  background-color: #41abc4;
  color: #fff;
  border-radius: 4px;
  height: 40px;
  max-width: 80%;
  font-size: 18px;
  font-weight: 300;

  margin-bottom: 10px;
  width: 300px;
}

.add-to-board-modal .el-button:hover {
  background-color: #2699b2;
}

.add-to-board-modal .el-checkbox {
  --el-checkbox-font-size: 14px;
  --el-checkbox-font-weight: var(--el-font-weight-primary);
  --el-checkbox-text-color: #3c3c3c;
  --el-checkbox-input-height: 14px;
  --el-checkbox-input-width: 14px;
  --el-checkbox-border-radius: 0;
  --el-checkbox-bg-color: white;
  --el-checkbox-input-border: 1px solid #41abc4;
  --el-checkbox-disabled-border-color: var(--el-border-color);
  --el-checkbox-disabled-input-fill: var(--el-fill-color-light);
  --el-checkbox-disabled-icon-color: var(--el-text-color-placeholder);
  --el-checkbox-disabled-checked-input-fill: var(--el-border-color-extra-light);
  --el-checkbox-disabled-checked-input-border-color: var(--el-border-color);
  --el-checkbox-disabled-checked-icon-color: var(--el-text-color-placeholder);
  --el-checkbox-checked-text-color: #3c3c3c;
  --el-checkbox-checked-input-border-color: #41abc4;
  --el-checkbox-checked-bg-color: #41abc4;
  --el-checkbox-checked-icon-color: var(--el-color-white);
  --el-checkbox-input-border-color-hover: #41abc4;

  height: 24px;
}

.add-to-board-modal a,
.add-to-board-modal a:hover,
.add-to-board-modal a:visited {
  color: rgb(60, 60, 60);
}

@media only screen and (max-width: 800px) {
  .add-to-board-modal :deep(.el-dialog) {
    --el-dialog-width: 95%;
    margin-top: 50px;
  }

  .add-to-board-modal :deep(.flex-wrap-on-mobile .el-form-item__content) {
    flex-wrap: wrap;
  }

  .add-to-board-modal .el-col-6,
  .add-to-board-modal .el-col-9 {
    max-width: 100%;
    flex: 0 0 100%;
    padding: 0;
  }

  .add-to-board-modal .el-col-6:not(:last-child),
  .add-to-board-modal .el-col-9:not(:last-child) {
    margin-bottom: 18px;
  }

  .add-to-board-modal .el-button {
    white-space: unset;
    height: unset;
  }
}

.add-to-board-modal :deep(.el-dialog) {
  --el-dialog-width: 800px;
  top: -100px !important;
}

.center {
  text-align: center;
}

.success-wrapper {
  color: #81bc8f;
  text-align: center;
  font-weight: bold;
  width: 100%;
  font-size: 16px;
}

.error-wrapper {
  color: #ff6b65;
  font-style: italic;
}

.add-to-board-modal :deep(.el-dialog .el-dialog__header) {
  padding-bottom: 0;
  margin-right: unset !important;
}

.add-to-board-modal
  :deep(
    .el-form--default.el-form--label-top .el-form-item .el-form-item__label
  ) {
  margin-bottom: 0px;
}

.add-to-board-modal .el-row {
  background-color: #ededed;
  color: rgb(60, 60, 60);
  padding-bottom: 18px;
}

.add-to-board-modal .el-row:first-child {
  padding-top: 18px;
}

.add-to-board-modal .el-row:nth-child(3) {
  margin-top: 20px;
  padding-top: 18px;
}

.add-to-board-modal .el-col {
  padding: 0 15px;
}

.add-to-board-modal .title-col {
  text-align: left;
  font: normal normal 500 24px/29px Barlow;
  letter-spacing: -0.24px;
  color: #3c3c3c;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgb(60, 60, 60);
  margin-left: 14px;
  width: 96%;
}

.add-to-board-modal-content > div:nth-child(1) {
  max-width: 60%;
  flex: 0 0 60%;
}

.add-to-board-modal-content > div:nth-child(2) {
  max-width: 40%;
  flex: 0 0 40%;
}

.add-to-board-modal .el-button {
  border-radius: 4px;
  height: 40px;
  width: 100%;
  max-width: 730px;
  font-size: 18px;
  font-weight: 300;
  border-color: #41abc4;
}

.add-to-board-modal .el-button.is-disabled {
  background-color: #bababa !important;
  border-color: #bababa !important;
}

.add-to-board-modal .el-button.is-disabled:hover {
  background-color: #bababa !important;
  border-color: #bababa !important;
}

.add-to-board-modal .el-button:not(.el-button--info) {
  background-color: #41abc4;
  color: #fff;
}

.add-to-board-modal .el-button:not(.el-button--info):hover {
  background-color: #2699b2;
}

.your-selection-content {
  display: block;
  max-height: 300px;
  overflow-y: auto;
}

.your-selection-row {
  display: flex;
  padding: 8px 16px;
}

.your-selection-row:not(:last-child) {
  padding-bottom: 4px;
  border-bottom: 1px solid rgb(60, 60, 60);
}

.your-selection-row > div:nth-child(1) > img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.your-selection-row > div:nth-child(2) {
  flex-grow: 1;
  padding: 5px 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  overflow-y: hidden;
}

.your-selection-row > div:nth-child(4) {
  display: flex;
  align-items: center;
}

.your-selection-row > div:nth-child(4):first-child {
  margin-top: -55px;
}

.your-selection-row > div:nth-child(4) > .el-icon {
  background-color: #41abc4;
  padding: 10px;
  width: 22px;
  height: 22px;
  border-radius: 10px;
  background-image: linear-gradient(#ff6b65 0 0);
  background-size: 100% 0em;
  background-repeat: no-repeat;
  transition: 0.1s;
}

.your-selection-row > div:nth-child(4) > .el-icon:hover {
  transition: 0.1s;
  background-size: 100% 100%;
  cursor: pointer;
}

.your-selection-row > div:nth-child(4) > .el-icon > svg {
  width: 22px;
  height: 22px;
}

.match-rate {
  font-size: 20px;
  min-width: 120px;
}

.tag-header {
  margin-left: 124px;
  font-weight: bold;
  font-size: 18px;
}

.match-rate-header {
  margin-left: 600px;
  bottom: 25px;
  position: relative;
  font-weight: bold;
  font-size: 18px;
}

@media only screen and (max-width: 500px) {
  .your-selection-content {
    max-height: unset;
  }

  .your-selection-row {
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .your-selection-row > div:nth-child(2) {
    order: 3;
    padding: 10px 0;
    width: 100%;
  }
}

/* max-wdith = width of modal + 50px */
@media only screen and (max-width: 850px) {
  .el-dialog {
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 8px;
    width: calc(100% - 30px);
    margin: 15px;
    box-sizing: border-box;
    overflow-y: scroll;
  }

  .add-to-board-modal :deep(.el-dialog) {
    --el-dialog-width: 95%;
  }

  .add-to-board-modal-content > div:nth-child(1) {
    max-width: 100%;
    flex: 0 0 100%;
  }

  .add-to-board-modal-content > div:nth-child(2) {
    display: none;
  }
}

@media only screen and (max-width: 790px) {
  .match-rate-header {
    margin-left: unset;
    bottom: 27px;
  }

  .tag-header .color-grey {
    margin-left: -108px;
  }

  .match-rate-header .color-grey {
    margin-left: 44%;
  }

  .match-rate {
    min-width: 75px;
  }
}
</style>
